import { render, staticRenderFns } from "./NotesLandingEmpty.vue?vue&type=template&id=601fada9&scoped=true&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "601fada9",
  null
  
)

export default component.exports